'use client';

// ============================================================================
// GoogleMapsPicker — now a thin re-export of LeafletMapPicker
// The original Google Maps implementation has been fully replaced by Leaflet.
// This file keeps the import path stable for all consumers.
// ============================================================================

export { default } from './LeafletMapPicker';
export type { LeafletMapPickerProps as GoogleMapsPickerProps } from './LeafletMapPicker';
